import { render, staticRenderFns } from "./dashboard-views-header-area.vue?vue&type=template&id=006c0752&scoped=true&"
import script from "./dashboard-views-header-area.ts?vue&type=script&lang=ts&"
export * from "./dashboard-views-header-area.ts?vue&type=script&lang=ts&"
import style0 from "./dashboard-views-header-area.scss?vue&type=style&index=0&id=006c0752&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006c0752",
  null
  
)

export default component.exports